<template>
    <div class="ingredient">

        <div class="ingredient__field ingredient__label">
            <slot></slot>
        </div>

        <div class="ingredient__close">
            <button v-on:click="$emit('remove')">
                <i class="fa fa-close"></i>
            </button>
        </div>

        <div class="ingredient__field ingredient__unit">
            <select v-model="ingredient.unit_id">
                <option
                        :value="unit.id"
                        v-for="unit in ingredient.ingredient.units"
                >
                    {{ unit.unit }}
                </option>
            </select>
        </div>

        <div class="ingredient__field ingredient__amount">
            <input type="number"
                   v-model="ingredient.amount"
                   @change="checkIngredientValue()"
                   @keyup="checkIngredientValue()"
            >
        </div>

        <div style="clear: both;"></div>
    </div>
</template>

<script>
    import IngredientsStore from '../srores/ingredients-store.js'

    export default {
        data() {
            return {
            ingredientsStore: IngredientsStore
            }
        },

        props: {
            index: {required: true}
        },

        mounted() {

        },

        computed: {
            ingredient() {
                return this.ingredientsStore.getIngredient(this.index);
            }
        },

        methods: {
            checkIngredientValue() {
                if ( this.ingredient.amount < 0 ) {
                    this.ingredient.amount = 0;
                }
            }
        }
    }
</script>

<style>

    .ingredient {
        padding: 0.2em 0;
    }

    .ingredient input, .ingredient select, .ingredient button {
        margin-bottom: 0;
        font-size: 0.9em;
    }

    .ingredient:hover {
        background-color: #f5f5f5;
    }

    .ingredient__field {
        float: right;
        margin-right: 0.5em;
    }

    .ingredient__amount {
        width: 80px;
    }

    .ingredient__unit {
        width: 150px;
    }

    .ingredient__label {
        float: left;
        width: 250px;
        padding-left: 0.5em;
        padding-top: 0.5em;
        font-size: 0.9em;
    }

    .ingredient__close {
        float: right;
        padding-right: 0.5em;
        padding-top: 0.5em;
        cursor: pointer;
    }
</style>